"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxQuickstart = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = require("styled-components");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const queries_1 = require("@src/types/queries");
const Api = __importStar(require("@src/api/account"));
const roundToClosestValue_1 = require("@src/helpers/roundToClosestValue");
const BoxQuickStart_styles_1 = require("./BoxQuickStart.styles");
const tiles = [
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.quickstart.item_1_headline" }),
        image: 'nomad-home-2',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.quickstart.item_1_text" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.quickstart.item_2_headline" }),
        image: 'workspace-imac-coffee-1',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.quickstart.item_2_text" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.quickstart.item_3_headline" }),
        image: 'app-launch-laptop',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.quickstart.item_3_text" }),
    },
];
const BoxQuickstart = () => {
    const theme = (0, styled_components_1.useTheme)();
    const { data: accountCounts } = (0, useAppQuery_1.useAppQuery)(queries_1.Queries.getAccountsCount, () => Api.getAllAccountsCount());
    return ((0, jsx_runtime_1.jsxs)(BoxQuickStart_styles_1.Box, { children: [(0, jsx_runtime_1.jsxs)(BoxQuickStart_styles_1.BoxMain, { children: [(0, jsx_runtime_1.jsx)(BoxQuickStart_styles_1.Quickstart, { children: tiles.map(item => {
                            return ((0, jsx_runtime_1.jsxs)(BoxQuickStart_styles_1.QuickstartTile, { children: [(0, jsx_runtime_1.jsx)(BoxQuickStart_styles_1.Picture, { children: (0, jsx_runtime_1.jsx)("img", { src: `/media/illustrations/streamline-icon-${item.image}.svg`, alt: "" }) }), (0, jsx_runtime_1.jsxs)(BoxQuickStart_styles_1.Content, { children: [(0, jsx_runtime_1.jsx)("dt", { children: item.name }), (0, jsx_runtime_1.jsx)("dd", { children: item.text })] })] }, item.image));
                        }) }), (0, jsx_runtime_1.jsx)(BoxQuickStart_styles_1.QuickstartCTA, { children: (0, jsx_runtime_1.jsx)(BoxQuickStart_styles_1.QuickstartCTAButton, { style: {
                                background: theme.color.success,
                                borderColor: theme.color.success,
                                color: theme.color.white,
                            }, link: "/prihlasenie", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.quickstart.cta" }) }) })] }), (0, jsx_runtime_1.jsx)(BoxQuickStart_styles_1.BoxBottom, { children: (0, jsx_runtime_1.jsx)(BoxQuickStart_styles_1.Claim, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.quickstart.subheadline", values: {
                            count: (0, jsx_runtime_1.jsxs)("strong", { children: [(0, roundToClosestValue_1.roundToClosestValue)(accountCounts, 100), "+"] }),
                            span: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
                            a: chunks => (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/ponuky", children: chunks }),
                        } }) }) })] }));
};
exports.BoxQuickstart = BoxQuickstart;
